import { Injectable, Optional, SkipSelf } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SpinnerService {
  visibleChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  timer: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor( @Optional() @SkipSelf() prior: SpinnerService) {
    if (prior) { return prior; }
  }

  show() {
    this.visibleChanged.next(true);
  }

  hide() {
    this.visibleChanged.next(false);
  }
}
